// extracted by mini-css-extract-plugin
module.exports = {"btn":"Index_btn___obRs","btnPrev":"Index_btnPrev__kxfmc","btnNext":"Index_btnNext__V4iBC"};